import classNames from "classnames";
import React from "react";

import FormGroup from "./FormGroup";
import OrderedProductOrderField from "./OrderedProductOrderField";

export default function OrderedProductOrderFieldFormGroup({
  name,
  error,
  valid = !error,
  value: orderedField,
  wrapperClassName,
  showCustomerHint = true,
  required,
  inputRequired = required,
  ...rest
}) {
  const field = orderedField.product_order_field;
  const label = field.display_name_with_price;
  const help = showCustomerHint && field.customer_hint;
  if (required === undefined) {
    required = field.order_value_required;
  }
  if (inputRequired === undefined) {
    inputRequired = required;
  }

  return (
    <FormGroup
      name={name}
      error={error}
      valid={valid}
      required={required}
      label={field.type !== "ProductOrderField::Boolean" ? label : null}
      help={field.type !== "ProductOrderField::Boolean" ? help : null}
      className={wrapperClassName}
    >
      <OrderedProductOrderField
        name={name}
        value={orderedField}
        required={inputRequired}
        label={field.type === "ProductOrderField::Boolean" ? label : null}
        help={field.type === "ProductOrderField::Boolean" ? help : null}
        {...rest}
      />
    </FormGroup>
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/OrderedProductOrderFieldFormGroup.jsx